module.exports = __webpack_public_path__ + "static/p6-0165890dd34d0fcb1cf62079dc9a043b.jpg";